import { render, staticRenderFns } from "./Despacho_Bodega_Romana.vue?vue&type=template&id=7ffc3652&scoped=true&"
import script from "./Despacho_Bodega_Romana.vue?vue&type=script&lang=js&"
export * from "./Despacho_Bodega_Romana.vue?vue&type=script&lang=js&"
import style0 from "./Despacho_Bodega_Romana.vue?vue&type=style&index=0&id=7ffc3652&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffc3652",
  null
  
)

export default component.exports